var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2164_4421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5024 0.666992H0V19.3337H32.5024V0.666992Z",
    fill: "#2D6B4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5024 4.4043H0V8.13191H32.5024V4.4043Z",
    fill: "#F5CD28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5024 11.8691H0V15.6063H32.5024V11.8691Z",
    fill: "#F5CD28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.37 0.666992H0V11.8689H11.37V0.666992Z",
    fill: "#C0003B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68509 2.7168L4.57133 6.09167L6.28555 6.63508L5.68509 2.7168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68495 2.7168L6.79871 6.09167L5.08449 6.63508L5.68495 2.7168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11347 5.16699H5.5107V6.94023L9.11347 5.16699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11344 5.16699L6.19829 7.25484L5.13296 5.81527L9.11344 5.16699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25651 5.16699L5.17165 7.25484L6.23699 5.81527L2.25651 5.16699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25651 5.16699H5.85928V6.94023L2.25651 5.16699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80599 9.13292L6.69223 5.76758L4.97801 6.31099L7.80599 9.13292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80606 9.13311L4.89091 7.0548L5.94656 5.61523L7.80606 9.13311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.56409 9.13311L6.47924 7.0548L5.42359 5.61523L3.56409 9.13311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.56409 9.13292L4.67785 5.76758L6.39207 6.31099L3.56409 9.13292Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2164_4421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 18.6667,
    fill: "white",
    transform: "translate(0 0.666992)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIcon);
export default __webpack_public_path__ + "static/media/flagIcon.7d46f8e09c84c17787615b8d463aaaf7.svg";
export { ForwardRef as ReactComponent };